import gql from 'graphql-tag';

export const initCalendarMutation = gql`
  mutation initCalendar(
    $provider: String!
    $redirectUri: String!
    $authorizationCode: String!
    $coursesIds: [String!]
    $disciplineInstancesIds: [String!]
  ) {
    initCalendar(
      provider: $provider
      redirectUri: $redirectUri
      authorizationCode: $authorizationCode
      coursesIds: $coursesIds
      disciplineInstancesIds: $disciplineInstancesIds
    ) {
      identifier
      message
      data {
        id
        provider
        providerCalendarId
        providerUserId
        status
        updatedAt
        userId
      }
    }
  }
`;
